import {
  B50,
  N900,
  B500,
  P500,
  N0,
  N20,
  Y200,
  R200,
  G200,
  T200,
  B200,
  P100,
  N500,
  N70,
  Y500
} from '@atlaskit/theme/colors';
import { BG_COLOR_PROPERTIES } from '../models/colors-props';

export const GRAY3 = '#505F79';
export const NUM_OF_CARDS = 3;
export const MIN_CYCLE_TIME = 7000;

export const DEFAULT_BG_COLOR = 'b50';

// Intersection options
export const INTERSECTION_OPTIONS = { threshold: 0.35 };

export enum LAYOUT_TYPE {
  CARDS_LEFT = 'cards_left',
  CARDS_RIGHT = 'cards_right'
}

export enum MEDIA_TYPE {
  VIDEO = 'video',
  IMAGE = 'image'
}

export enum SWIPE_DIRECTION {
  LEFT = 'left',
  RIGHT = 'right'
}

/* ---------------------BG COLOR CODINGS---------------------------*/

export const BG_COLOR_CODING_MAP: {
  [key: string]: BG_COLOR_PROPERTIES;
} = {
  b50: {
    colorCode: B50,
    typeColor: N900,
    cardActiveColor: N0,
    cardHoverColor: `${N0}50`,
    categoryTypeColor: GRAY3,
    paginationColorActive: N500,
    paginationColorInactive: N0
  },
  n0: {
    colorCode: N0,
    typeColor: N900,
    cardActiveColor: N20,
    cardHoverColor: `${N20}50`,
    categoryTypeColor: GRAY3,
    paginationColorActive: N500,
    paginationColorInactive: N70
  },
  n900: {
    colorCode: N900,
    typeColor: N0,
    cardActiveColor: `${N0}10`,
    cardHoverColor: `${N0}20`,
    categoryTypeColor: N0,
    paginationColorActive: Y500,
    paginationColorInactive: N0
  },
  p500: {
    colorCode: P500,
    typeColor: N0,
    cardActiveColor: `${N0}10`,
    cardHoverColor: `${N0}20`,
    categoryTypeColor: N0,
    paginationColorActive: Y500,
    paginationColorInactive: N0
  },
  b500: {
    colorCode: B500,
    typeColor: N0,
    cardActiveColor: `${N0}10`,
    cardHoverColor: `${N0}20`,
    categoryTypeColor: N0,
    paginationColorActive: Y500,
    paginationColorInactive: N0
  }
};

/* ---------------------BAR COLOR CODINGS---------------------------*/
export const BAR_COLOR_CODING_MAP: Map<string, string> = new Map<
  string,
  string
>();

BAR_COLOR_CODING_MAP.set('y200', Y200);
BAR_COLOR_CODING_MAP.set('r200', R200);
BAR_COLOR_CODING_MAP.set('g200', G200);
BAR_COLOR_CODING_MAP.set('t200', T200);
BAR_COLOR_CODING_MAP.set('b200', B200);
BAR_COLOR_CODING_MAP.set('p100', P100);

/* ---------------- Analytics event data -----------------------*/
export const defaultAnalyticsData = {
  eventComponent: 'featuresHighlightComponent',
  eventContainer: 'featuresHighlightContainer'
};
